module.exports = __webpack_public_path__ + "img/isls-thumbnail.a5d3bec5.png";